var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2D3065"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6669 11.9999H7.61248M7.49756 12.5314L6.82772 14.5323C6.46085 15.6282 6.27742 16.1761 6.40906 16.5135C6.52338 16.8066 6.7689 17.0287 7.07187 17.1133C7.42074 17.2106 7.94767 16.9735 9.00154 16.4993L15.7578 13.459C16.7865 12.9961 17.3008 12.7646 17.4598 12.4431C17.5979 12.1638 17.5979 11.836 17.4598 11.5567C17.3008 11.2352 16.7865 11.0037 15.7578 10.5408L8.98989 7.49527C7.9392 7.02246 7.41385 6.78606 7.06533 6.88304C6.76265 6.96726 6.51715 7.18883 6.40243 7.48131C6.27034 7.8181 6.45182 8.36486 6.81476 9.45837L7.49886 11.5194C7.5612 11.7073 7.59236 11.8012 7.60467 11.8972C7.61559 11.9824 7.61548 12.0687 7.60434 12.1539C7.59179 12.2499 7.56038 12.3437 7.49756 12.5314Z",
    stroke: "#C0C9FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageIcon);
export default __webpack_public_path__ + "static/media/sendMessageIcon.2088b86eb8bd669dce756cb15780ba61.svg";
export { ForwardRef as ReactComponent };